import { Link } from "react-router-dom";
import { formatViews, type Comic } from "../../mocks/comics";

export default function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/manhua/${comic.id}`}
      className="group block rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:-translate-y-1 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - ${comic.category}漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          <span className={`px-2 py-0.5 rounded-md text-[11px] font-medium ${comic.status === "已完结" ? "bg-accent-500 text-foreground-950" : "bg-primary-500 text-background-50"}`}>
            {comic.status}
          </span>
          {comic.isEditorPick && (
            <span className="px-2 py-0.5 rounded-md text-[11px] font-medium bg-foreground-900/80 text-accent-300">
              编辑精选
            </span>
          )}
        </div>
        {rank !== undefined && (
          <span className="absolute left-2 bottom-2 w-7 h-7 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-base">
            {rank}
          </span>
        )}
        <span className="absolute right-2 bottom-2 px-2 py-0.5 rounded-md text-[11px] bg-foreground-950/70 text-background-50 flex items-center gap-1">
          <i className="ri-eye-line"></i>{formatViews(comic.views)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-[15px] font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 truncate flex items-center gap-2">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap">
            {comic.category}
          </span>
          <span className="truncate">{comic.author}</span>
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1 text-accent-700">
            <i className="ri-star-fill text-accent-500"></i>
            <span className="font-semibold">{comic.score.toFixed(1)}</span>
          </span>
          <span className="text-foreground-500">{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}